import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from '@mui/material/TextField'
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import {useEffect, useState} from "react";
import {useRef, useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {useCookies} from "react-cookie";
import CssBaseline from "@mui/material/CssBaseline";
import SideMenu from "../components/SideMenu";
import {alpha} from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Header from "../components/Header";
import AppTheme from "../mui-theme/AppTheme";
import ibantools from "ibantools";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import {
    chartsCustomizations,
    dataGridCustomizations,
    datePickersCustomizations,
    treeViewCustomizations,
} from '../theme/customizations';
import MouseTracker from "../components/MouseTracker";
import Link from "@mui/material/Link";

const xThemeComponents = {
    ...chartsCustomizations,
    ...dataGridCustomizations,
    ...datePickersCustomizations,
    ...treeViewCustomizations,
};

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

/**
 * Parses a user-inputted amount string into cents.
 * Handles various formats with dots and commas as decimal or thousands separators.
 * @param {string} input The raw string from the input field.
 * @returns {{value: string|null, error: string|null}}
 */
const parseAmountToCents = (input) => {
    if (!input || typeof input !== 'string' || input.trim() === '') {
        return {value: null, error: 'Der Bterag darf nicht leer sein.'};
    }

    // Allow only digits, commas, and dots.
    if (/[^0-9,.]/.test(input)) {
        return {value: null, error: 'Der Betrag darf nur Ziffern, ein Komma und Punkte enthalten.'};
    }

    const lastDot = input.lastIndexOf('.');
    const lastComma = input.lastIndexOf(',');

    let integerPart;
    let fractionalPart;

    if (lastDot === -1 && lastComma === -1) {
        // Case 1: No decimal separator (e.g., "1234")
        integerPart = input.replace(/[.,]/g, '');
        fractionalPart = '00';
    } else {
        // Case 2: Decimal separator is the last one found
        let decimalSeparatorIndex;
        if (lastDot > lastComma) {
            decimalSeparatorIndex = lastDot;
        } else {
            decimalSeparatorIndex = lastComma;
        }

        integerPart = input.substring(0, decimalSeparatorIndex);
        fractionalPart = input.substring(decimalSeparatorIndex + 1);

        // The fractional part cannot contain any more separators
        if (/[.,]/.test(fractionalPart)) {
            return {value: null, error: 'Ungültiges Format der Dezimalstellen.'};
        }
    }

    // Clean up integer part by removing all separators
    integerPart = integerPart.replace(/[.,]/g, '');

    // Validate fractional part
    if (fractionalPart.length > 2) {
        return {value: null, error: 'Die Goliath National Bank kann keine Bruchteile von Cents verarbeiten. Bitte auf Cents runden.'};
    }

    // Pad fractional part if necessary
    if (fractionalPart.length === 1) {
        fractionalPart += '0';
    }
    if (fractionalPart.length === 0) { // e.g., user types "12,"
        fractionalPart = '00';
    }

    // Combine and convert to number
    const finalCentsString = (integerPart || '0') + fractionalPart;

    // Handle empty input after cleaning, e.g. "," or "."
    if (finalCentsString === '00' && integerPart === '') {
        return {value: null, error: 'Der Betrag darf nicht leer sein.'};
    }

    const value = parseInt(finalCentsString, 10);

    if (isNaN(value)) {
        return {value: null, error: 'Ungültiges Format im Betragsfeld. Bitte Zahlen wie 1234,56 angeben.'};
    }

    if (value <= 0) {
        return {value: null, error: 'Der Betrag muss eine positive Zahl sein.'};
    }

    return {value: value.toString(), error: null};
};

function BahamasAdPopup({open, handleDialogClose, handleDecision}) {
    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            TransitionComponent={Transition}
            aria-labelledby="advertisement-dialog-title"
            aria-describedby="advertisement-dialog-description"
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle id="advertisement-dialog-title" sx={{fontWeight: 'bold', fontSize: '1.4rem', p: 3, pb: 2}}>
                Ihr Sommer wird heisser. Ihre Rendite auch.
            </DialogTitle>
            <DialogContent sx={{
                maxHeight: '60vh',
                p: 3,
                pt: 1,
                borderTop: 1,
                borderBottom: 1,
                borderColor: 'divider'
            }}> {/* Control height and force scroll */}
                <img
                    src="/bahamas_werbung.jpg"
                    alt="Sonniger Strand auf den Bahamas"
                    style={{width: '100%', height: 'auto', borderRadius: '8px', marginBottom: '24px'}}
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = 'https://placehold.co/600x300/0284c7/FFFFFF?text=Bahamas+Investment';
                    }}
                />
                <DialogContentText id="advertisement-dialog-description" component="div">
                    <Typography variant="body1" sx={{fontSize: '1.1rem', lineHeight: 1.7, mb: 3}}>
                        Träumen Sie auch von weißen Sandstränden, dem sanften Rauschen der Wellen und einer kühlen Brise
                        unter Palmen, während Sie auf die nächste Abrechnung warten? Stellen Sie sich vor, dieser Traum
                        wäre nicht nur eine flüchtige Urlaubserinnerung, sondern ein solides Fundament für Ihre
                        finanzielle Zukunft. Die Goliath National Bank macht diesen Sommer Ihre Träume greifbar – und
                        profitabel. Vergessen Sie Sandburgen, bauen Sie an Ihrem Vermögen!
                    </Typography>
                    <Typography variant="body1" sx={{fontSize: '1.1rem', lineHeight: 1.7, mb: 3}}>
                        Mit unserem exklusiven Sommer-Sparangebot "Bahama-Beteiligung" investieren Sie nicht einfach
                        nur, Sie sichern sich ein Stück vom Paradies. Wir bieten Ihnen die einmalige und streng
                        limitierte Chance, Anteile an vielversprechenden Unternehmensstrukturen an einem der sonnigsten
                        und wirtschaftlich attraktivsten Standorte der Welt zu erwerben: den Bahamas. Profitieren Sie
                        von maximaler unternehmerischer Freiheit und einem Geschäftsumfeld, das so entspannt ist wie ein
                        Nachmittag in der Hängematte.
                    </Typography>
                    <Typography variant="body1" sx={{fontSize: '1.1rem', lineHeight: 1.7, mb: 3}}>
                        Lassen Sie Ihr Geld dort arbeiten, wo andere nur Urlaub machen. Während Ihr Portfolio in der
                        karibischen Sonne wächst, können Sie sich entspannt zurücklehnen. Der Einstieg ist dank unseres
                        exklusiven Online-Angebots so einfach und erfrischend wie ein Sprung ins kühle Nass. Klicken Sie
                        jetzt und verwandeln Sie Ihre Sommerträume in handfeste Werte.
                    </Typography>
                    <Typography variant="body1" sx={{fontWeight: 'bold', mt: 2, fontSize: '1.1rem'}}>
                        Goliath National Bank. Wir bringen Ihr Vermögen an die sonnigsten Plätze der Welt.
                    </Typography>
                </DialogContentText>
                <DialogActions sx={{p: 3}}>
                    <Button onClick={() => handleDecision('invest')} color="primary" variant="contained">
                        Jetzt investieren
                    </Button>
                    <Button onClick={() => handleDecision('close')} color="primary">
                        Schließen
                    </Button>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

function DsgvoConsentPopup({open, handleDialogClose, handleDecision}) {
    return (
        <Dialog
            open={open}
            onClose={() => handleDialogClose}
            TransitionComponent={Transition}
            aria-labelledby="dsgvo-dialog-title"
            maxWidth="md"
            fullWidth
        >
            <DialogTitle id="dsgvo-dialog-title" sx={{fontWeight: 'bold', fontSize: '1.5rem', p: 3}}>
                Datenverarbeitungs-Einwilligung
            </DialogTitle>
            <DialogContent sx={{maxHeight: '480px', p: 3, borderTop: 1, borderColor: 'divider'}}>
                <DialogContentText component="div" sx={{color: 'text.primary'}}>
                    <Typography variant="body1" sx={{mb: 2}}>
                        Für maximale Transparenz und zur kontinuierlichen Verbesserung unserer Services bitten wir im
                        Rahmen Ihrer aktuellen Transaktion um Ihre Zustimmung zu folgender Datenverarbeitung gemäß Art.
                        6 Abs. 1 lit. a DSGVO.
                    </Typography>

                    <Typography variant="h6" sx={{fontWeight: 'bold', mt: 3, mb: 1, fontSize: '1.1rem'}}>
                        Zweck der Datenverarbeitung und Weitergabe an Dritte
                    </Typography>
                    <Typography variant="body1" sx={{mb: 2}}>
                        Ich willige ein, dass die Goliath National Bank die im Rahmen dieser und zukünftiger
                        Überweisungen anfallenden Transaktionsdaten (insbesondere Empfängername, IBAN, Verwendungszweck,
                        Betrag und Transaktionszeitpunkt) verarbeitet und an sorgfältig ausgewählte Drittunternehmen und
                        Partner (z.B. aus den Branchen E-Commerce, Reisen, Versicherungen und Finanzdienstleistungen)
                        übermitteln darf. Diese Übermittlung erfolgt zum Zwecke der Erstellung und Zusendung von
                        personalisierten und für Sie hochrelevanten Werbeangeboten durch diese Drittunternehmen. Dies
                        ermöglicht es unseren Partnern, sowohl Ihnen als auch dem Empfänger der Zahlung exklusive und
                        vorteilhafte Produktinformationen und Dienstleistungen anzubieten.
                    </Typography>

                    <Typography variant="h6" sx={{fontWeight: 'bold', mt: 3, mb: 1, fontSize: '1.1rem'}}>
                        Freiwilligkeit und Widerruf
                    </Typography>
                    <Typography variant="body1">
                        Diese Einwilligung ist freiwillig und kann jederzeit mit Wirkung für die Zukunft in Ihren
                        Profileinstellungen oder durch eine formlose Mitteilung an uns widerrufen werden. Die
                        Durchführung Ihrer aktuellen Überweisung ist von dieser Einwilligung nicht abhängig. Ohne Ihre
                        Zustimmung entgehen Ihnen und dem Zahlungsempfänger jedoch möglicherweise exklusive
                        Preisvorteile und maßgeschneiderte Angebote aus unserem Partnernetzwerk.
                    </Typography>
                </DialogContentText>
                <DialogActions sx={{p: 3, display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 2}}>
                    <Button onClick={() => handleDecision(true)} color="primary" variant="contained" size="large">
                        Ja, zustimmen und Überweisung fortsetzen
                    </Button>
                    <Link component="button" variant="body2" onClick={() => handleDecision(false)}
                          sx={{textAlign: 'center'}}>
                        Ohne Zustimmung nur Überweisung ausführen
                    </Link>
                </DialogActions>
            </DialogContent>
        </Dialog>
    );
}

export default function Transaction(props) {
    const ibantools = require('ibantools');
    const [transferType, setTransferType] = useState('oneTime'); // Default to one-time transfer
    const [error, setError] = useState(null);
    const [sourceIBANs, setSourceIBANs] = useState([""]);
    const [selectedIBANno, setSelectedIBANno] = useState(0);
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [sendIBAN, setSendIBAN] = useState("");
    const [sendIBANError, setSendIBANError] = useState('');
    const [bic, setBic] = useState('');
    const [bicError, setBicError] = useState('');
    const [amount, setAmount] = useState('');
    const [amountError, setAmountError] = useState('');
    const [purpose, setPurpose] = useState('');
    const [reference, setReference] = useState('');
    const navigate = useNavigate();
    const [cookies, setCookie, removeCookie] = useCookies(['session-token']);
    const [adPopupOpen, setAdPopupOpen] = useState(false);
    const [dsgvoPopupOpen, setDsgvoPopupOpen] = useState(false);
    const [dsgvoConsentGiven, setDsgvoConsentGiven] = useState(null);
    const [popupConfig, setPopupConfig] = useState(null);
    const activePopupRef = useRef(null);
    const popupQueueRef = useRef([]);
    const adPopupHasBeenTriggered = useRef(false);
    const dsgvoPopupHasBeenTriggered = useRef(false);
    const adTimerRef = useRef(null);

    const logPopupInteraction = (payload) => {
        fetch('/api/log_popup_interaction', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                ...payload
            })
        }).catch(err => console.error("Could not log popup interaction:", err));
    };

    const openOrQueuePopup = useCallback((popupType) => {
        if (activePopupRef.current === null) {
            // No popup is open, show this one immediately
            activePopupRef.current = popupType;
            if (popupType === 'ad') setAdPopupOpen(true);
            if (popupType === 'dsgvo') setDsgvoPopupOpen(true);
        } else {
            // Another popup is open, add this one to the queue if it's not already there
            if (!popupQueueRef.current.includes(popupType)) {
                popupQueueRef.current.push(popupType);
            }
        }
    }, []);

    const showNextInQueue = useCallback(() => {
        if (popupQueueRef.current.length > 0) {
            const nextPopup = popupQueueRef.current.shift(); // Get the next item

            // Wait 5 seconds before showing the next one
            setTimeout(() => {
                openOrQueuePopup(nextPopup);
            }, 5000);
        }
    }, [openOrQueuePopup]);

    const handleAdDialogCloseAttempt = (event, reason) => {
        logPopupInteraction({popup_type: 'bahamas_ad', action: 'no close', reason: reason});
        // This is the gatekeeper. If the user clicks the backdrop or presses Escape,
        // we do nothing, effectively preventing the dialog from closing.
        if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
        }
    };

    const handleAdPopupClose = useCallback((action) => {
        logPopupInteraction({popup_type: 'bahamas_ad', action: action});
        setAdPopupOpen(false);
        activePopupRef.current = null; // Free up the active slot
        showNextInQueue(); // Check if another popup is waiting
    }, [logPopupInteraction, showNextInQueue]);

    const handleDsgvoDialogCloseAttempt = (event, reason) => {
        logPopupInteraction({popup_type: 'dsgvo_consent', action: 'no close', reason: reason});
        // This is the gatekeeper. If the user clicks the backdrop or presses Escape,
        // we do nothing, effectively preventing the dialog from closing.
        if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
        }
    };

    const handleDsgvoPopupClose = useCallback((consent) => {
        logPopupInteraction({ popup_type: 'dsgvo_consent', consent: consent });
        setDsgvoConsentGiven(consent);
        setDsgvoPopupOpen(false);
        activePopupRef.current = null;

        if (popupConfig && popupConfig.popup_rule !== 'never' && popupConfig.ad_popup_after_seconds > 0 && !adPopupHasBeenTriggered.current) {
            adTimerRef.current = setTimeout(() => {
                openOrQueuePopup('ad');
            }, popupConfig.ad_popup_after_seconds * 1000);
            adPopupHasBeenTriggered.current = true;
        } else {
            showNextInQueue();
        }
    }, [logPopupInteraction, showNextInQueue, popupConfig, openOrQueuePopup]);

    useEffect(() => {
        // Fetch account and session data
        const token = cookies['session-token'];
        if (typeof token !== "string" || token.length <= 0) {
            navigate('/sign-in');
            return;
        }

        fetch('/api/account_IBANs', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({session: token})
        }).then(res => {
            if (!res.ok) {
                if (res.status === 401) {
                    removeCookie('session-token', {path: '/'});
                    navigate('/sign-in');
                }
                throw new Error(`HTTP error! status: ${res.status}`);
            }
            return res.json();
        }).then(data => {
            setSourceIBANs(data.IBANs);
        });

        fetch('/api/session_info', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({session: token})
        }).then(res => {
            if (!res.ok) throw new Error('Could not fetch session info');
            return res.json();
        }).then(data => {
            setPopupConfig(data);
        }).catch(err => console.error(err));

    }, [cookies, navigate, removeCookie, openOrQueuePopup]);

    useEffect(() => {
        return () => {
            if (adTimerRef.current) {
                clearTimeout(adTimerRef.current);
            }
        };
    }, []);

    const handleSourceChange = (event) => {
        fetch('/api/capture_keystroke', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                field: 'sourceIBANselected',
                value: sourceIBANs[event.target.value],
            })
        })
        setSelectedIBANno(event.target.value);
    }

    const handleNameBlur = (event) => {
        const nameInput = event.target;
        if (nameInput.value.length > 0) {
            setNameError('');
            // --- Trigger for DSGVO Popup ---
            // Use the stored config to decide if and when to show the DSGVO popup
            if (popupConfig &&
                popupConfig.popup_rule !== 'never' &&
                popupConfig.dsgvo_popup_after_name_blur_seconds >= 0 &&
                !dsgvoPopupHasBeenTriggered.current) {
                setTimeout(() => {
                    openOrQueuePopup('dsgvo');
                }, Math.round(popupConfig.dsgvo_popup_after_name_blur_seconds * 1000));
                dsgvoPopupHasBeenTriggered.current = true;
            }
        } else {
            setNameError('Der zum Empfängerkonto gehörende Name darf nicht leer sein.');
        }
    };

    const handleNameChange = (event) => {
        setName(event.target.value);
        fetch('/api/capture_keystroke', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                field: 'name',
                value: event.target.value,
            })
        });
    };

    const validateIban = () => {
        const sendIBANInput = document.getElementById('iban');
        fetch('/api/capture_keystroke', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                field: 'sendIBAN',
                value: sendIBANInput.value,
            })
        })
        let validationResult = ibantools.validateIBAN(sendIBANInput.value.replace(/\s/g, ''))
        if (validationResult.valid) {
            setSendIBAN(sendIBANInput.value.replace(/\s/g, ''));
            setSendIBANError('');
            return true;
        } else {
            setSendIBANError('Die eingegebene IBAN ist unvollständig oder fehlerhaft.');
            return false;
        }
    };

    const validateBic = () => {
        const bicInput = document.getElementById('bic');
        fetch('/api/capture_keystroke', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                field: 'BIC',
                value: bicInput.value,
            })
        })
        if (ibantools.isValidBIC(bicInput.value)) {
            setBic(bicInput.value);
            setBicError('');
            return true;
        } else {
            setBicError('Die eingegebene BIC ist unvollständig oder fehlerhaft.')
        }
    };

    const validateAmount = () => {
        const amountInput = document.getElementById('amount');
        const rawValue = amountInput.value;

        fetch('/api/capture_keystroke', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                field: 'amount_raw',
                value: rawValue,
            })
        });

        const {value, error} = parseAmountToCents(rawValue);

        if (error) {
            setAmountError(error);
            setAmount(''); // Clear invalid amount
            return false;
        } else {
            setAmount(value); // Store the amount in cents
            setAmountError('');
            return true;
        }
    }

    const validatePurpose = () => {
        const purposeInput = document.getElementById('purpose');
        fetch('/api/capture_keystroke', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                field: 'purpose',
                value: purposeInput.value,
            })
        })
        setPurpose(purposeInput.value);
        return true;
    }

    const validateReference = () => {
        const referenceInput = document.getElementById('reference');
        fetch('/api/capture_keystroke', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                field: 'reference',
                value: referenceInput.value,
            })
        })
        setReference(referenceInput.value);
        return true;
    }

    const handleSubmit = (event) => {
        event.preventDefault();

        // Run all validations
        const isNameValid = name.length > 0;
        const isIbanValid = validateIban();
        const isBicValid = validateBic();
        const isAmountValid = validateAmount();

        if (!isNameValid || !isIbanValid || !isBicValid || !isAmountValid) {
            setError('Please correct the errors before proceeding.');
            if (!isNameValid) setNameError('Der zum Empfängerkonto gehörende Name darf nicht leer sein.');
            return;
        }
        setError(null);

        // TODO: Still want to simulate a potential error?
        // if (Math.random() < 0.5)

        fetch('/api/submit_transaction_form', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                session: cookies['session-token'],
                data: {
                    name: name,
                    sendIBAN: sendIBAN,
                    bic: bic,
                    amount: amount,
                    purpose: purpose,
                    reference: reference,
                    transferType: transferType,
                    sourceIBAN: sourceIBANs[selectedIBANno],
                }
            })
        }).then(res => {
            if (res.ok) {
                navigate('/transaction/check');
            } else {
                setError('Failed to submit transaction data. Please try again.');
            }
        }).catch(err => {
            console.error(err);
            setError('An unexpected error occurred.');
        });
    };

    return (
        <>
            <CssBaseline enableColorScheme/>
            <MouseTracker/>
            <Box sx={{display: 'flex'}}>
                <SideMenu selected={-1}/>
                {/* Main content */}
                <Box
                    component="main"
                    sx={(theme) => ({
                        flexGrow: 1,
                        backgroundColor: theme.vars
                            ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
                            : alpha(theme.palette.background.default, 1),
                        overflow: 'auto',
                    })}
                >
                    <Stack
                        spacing={2}
                        sx={{
                            alignItems: 'center',
                            mx: 3,
                            pb: 5,
                            mt: {xs: 8, md: 0},
                        }}
                    >
                        <Box sx={{width: '100%', maxWidth: {sm: '100%', md: '1700px'}}} component="form"
                             onSubmit={handleSubmit}>
                            <Typography component="h2" variant="h2" sx={{mb: 2}}>
                                Überweisung
                            </Typography>

                            <div style={{maxWidth: '50em'}}>
                                <FormControl fullWidth margin="normal">
                                    <InputLabel id="source-account-label" sx={{top: '-7px'}}>Abbuchen von</InputLabel>
                                    <Select variant="outlined"
                                            labelId="source-account-label"
                                            id="source-account-select"
                                            value={selectedIBANno}
                                            onChange={handleSourceChange}
                                            label="Abbuchen von"
                                    >
                                        {sourceIBANs.map((sourceIBAN, index) => (
                                            <MenuItem value={index} key={sourceIBAN}>Girokonto {sourceIBAN}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <Typography variant="h6">
                                    Überweisen an
                                </Typography>

                                <TextField
                                    fullWidth
                                    sx={{'.MuiFormLabel-root[data-shrink=false]': {top: '-7px'}}}
                                    variant="outlined"
                                    margin="normal"
                                    label="Name"
                                    id="name"
                                    autoFocus
                                    autoComplete="off"
                                    required
                                    value={name}
                                    onChange={handleNameChange}
                                    onBlur={handleNameBlur} // Logic now triggers on blur
                                    error={!!nameError}
                                    helperText={nameError}
                                    color={nameError ? 'error' : 'primary'}
                                />

                                <TextField
                                    fullWidth
                                    sx={{'.MuiFormLabel-root[data-shrink=false]': {top: '-7px'}}}
                                    variant="outlined"
                                    margin="normal"
                                    label="IBAN"
                                    id="iban"
                                    autoComplete="off"
                                    required
                                    onChange={validateIban}
                                    error={sendIBANError.length > 0}
                                    helperText={sendIBANError}
                                    color={sendIBANError.length > 0 ? 'error' : 'primary'}
                                />

                                <TextField
                                    fullWidth
                                    sx={{'.MuiFormLabel-root[data-shrink=false]': {top: '-7px'}}}
                                    variant="outlined"
                                    margin="normal"
                                    label="BIC"
                                    id="bic"
                                    autoComplete="off"
                                    required
                                    onChange={validateBic}
                                    error={bicError.length > 0}
                                    helperText={bicError}
                                    color={bicError.length > 0 ? 'error' : 'primary'}
                                />

                                <TextField
                                    fullWidth
                                    sx={{'.MuiFormLabel-root[data-shrink=false]': {top: '-7px'}}}
                                    variant="outlined"
                                    margin="normal"
                                    label="Betrag in €"
                                    id="amount"
                                    autoComplete="off"
                                    required
                                    onBlur={validateAmount} // Validate on blur
                                    error={amountError.length > 0}
                                    helperText={amountError}
                                    color={amountError.length > 0 ? 'error' : 'primary'}
                                />

                                <TextField
                                    fullWidth
                                    sx={{'.MuiFormLabel-root[data-shrink=false]': {top: '-7px'}}}
                                    variant="outlined"
                                    margin="normal"
                                    label="Verwendungszweck (optional)"
                                    id="purpose"
                                    autoComplete="off"
                                    onChange={validatePurpose}
                                    //onChange={}
                                />

                                <TextField
                                    fullWidth
                                    sx={{'.MuiFormLabel-root[data-shrink=false]': {top: '-7px'}}}
                                    variant="outlined"
                                    margin="normal"
                                    label="Kundenreferenz (optional)"
                                    id="reference"
                                    autoComplete="off"
                                    onChange={validateReference}
                                />

                                <Typography variant="h6" gutterBottom>
                                    Ausführung
                                </Typography>

                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    margin="normal"
                                    value={transferType}
                                    onChange={(event) => setTransferType(event.target.value)}
                                >
                                    <FormControlLabel
                                        value="oneTime"
                                        control={<Radio/>}
                                        label="Einmalige Überweisung"
                                    />
                                    <FormControlLabel
                                        value="standingOrder"
                                        control={<Radio/>}
                                        label="Dauerauftrag"
                                    />
                                </RadioGroup>

                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    fullWidth
                                >
                                    Überprüfen
                                </Button>

                                {error && (
                                    <Alert severity="error" sx={{mt: 2}}>
                                        {error}
                                    </Alert>
                                )}

                                <BahamasAdPopup
                                    open={adPopupOpen}
                                    handleDialogClose={handleAdDialogCloseAttempt}
                                    handleDecision={handleAdPopupClose}
                                />
                                <DsgvoConsentPopup
                                    open={dsgvoPopupOpen}
                                    handleDialogClose={handleDsgvoDialogCloseAttempt}
                                    handleDecision={handleDsgvoPopupClose}
                                />
                            </div>
                        </Box>

                    </Stack>
                </Box>
            </Box>
        </>
    );
}